<template>
  <div>
    <div
      v-for="(regProduct, i) in registrationEventProducts"
      :key="regProduct.id + i"
      class="d-flex flex-row justify-space-between mb-2"
    >
      <div>
        {{ regProduct.eventProduct.name }}
        <template v-if="regProduct.entry"
          ><template v-if="regProduct.entry">
            ( {{ regProduct.entry.competition.code }})
          </template></template
        >
      </div>
      <div>
        <AppShowPaymentStatus
          v-if="useOnlinePayments && regProduct.paymentStatus"
          :status="regProduct.paymentStatus"
          :reg-event-product-paid-externally="regProduct.paidExternally"
          :ignore="['PAID', 'IN_PROCESS']"
          small
        />
      </div>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowPaymentStatus from "@/components/elements/AppShows/AppShowPaymentStatus.vue";

export default {
  name: "AppShowEntryProducts",
  components: { AppShowPaymentStatus },
  props: {
    registrationEventProducts: {
      type: Array,
      required: true
    },
    useOnlinePayments: {
      type: Boolean,
      required: true
    }
  },
  fragments: {
    entryFields: gql`
      fragment _ on Entry {
        status
        resolution
        competition {
          id
          code
        }
      }
    `
  }
};
</script>
